interface RecentUser {
  id: number;
  name?: string;
  email?: string;
  parent?: boolean;
  sitter?: boolean;
  pictureUrl?: string;
}

const RECENT_USERS_KEY = 'admin_recent_users';
const MAX_RECENT_USERS = 12;

export function getRecentUsers(): RecentUser[] {
  try {
    const stored = localStorage.getItem(RECENT_USERS_KEY);

    if (!stored) {
      return [];
    }

    const parsed: unknown = JSON.parse(stored);

    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.filter(
      (item): item is RecentUser =>
        typeof item === 'object' &&
        item !== null &&
        typeof (item as RecentUser).id === 'number',
    );
  } catch {
    return [];
  }
}

export function addRecentUser(user: RecentUser): void {
  try {
    const recent = getRecentUsers();
    const filtered = recent.filter(u => u.id !== user.id);
    const updated = [user, ...filtered].slice(0, MAX_RECENT_USERS);

    localStorage.setItem(RECENT_USERS_KEY, JSON.stringify(updated));
  } catch {
    // Ignore storage errors
  }
}

export function clearRecentUsers(): void {
  try {
    localStorage.removeItem(RECENT_USERS_KEY);
  } catch {
    // Ignore storage errors
  }
}
